import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Container, Grid, Link } from "@material-ui/core";
import instagramIcon from "../../../assets/icons/icon-instagram.svg";
import PhoneIcon from '../../../assets/icons/whatsapp.svg'
const useStyles = makeStyles((theme) => ({
  footerContainer: {
    maxWidth: 'none',
    width: "100%",
    margin: 0,
  },
  link: {
    margin: theme.spacing(1, 0),
    color: "#4E5258",
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  hr: {
    margin: theme.spacing(4, 4), 
  },
  title: {
    color: "#39ADC4",
  },
  linkBoxesWrapper: {
    width: '100%',
    display: "flex",
    flexDirection: "row",
    flexWrap: 'wrap',
  },
  centralize: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  linkBoxes: {
    display: "flex",
    flexDirection: "column",
  },
  links: {
    width: 'auto',
    display: "flex",
    flexDirection: "column",
    alignItems: 'flex-start',
    marginLeft: theme.spacing(10),
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(4),
    },
  },
  spacing: {
    margin: theme.spacing(5, 0),
  },
  body2:{
    fontSize: '0.875rem',
    fontFamily: "Roboto",
    fontWeight: 400,
    lineHeight: 1.43,
    letterSpacing: '0.01071em',
  }
}));

export default function PageFooter() {
  const classes = useStyles();

  return (
    <Container component="footer" className={classes.footerContainer}>
      <hr className={classes.hr} />
      <Grid container className={classes.linkBoxes}>
        <Grid className={classes.linkBoxesWrapper}>
          <Grid container className={classes.links}>
            <Link href="https://api.whatsapp.com/send?phone=5516993523284&text=Ol%C3%A1!%20Vim%20do%20site,%20gostaria%20de%20saber%20mais%20sobre%20o%20Z%20Doctors&source=&data=" className={classes.link}>
              <Grid className={classes.centralize}>
                <img src={PhoneIcon} className={classes.icon} alt="Phone icon"/>
                WhatsApp (16)993523284
              </Grid>
            </Link>
            <Link href="https://www.instagram.com/z.doctors?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" className={classes.link}>
              <Grid className={classes.centralize}>
                <img src={instagramIcon} className={classes.icon} alt="Instagram Icon" />
                @z.doctors
              </Grid>
            </Link>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.spacing}>
          <Typography variant="body2" color="textSecondary" align="center">
          Endereço: Avenida Wladimir Meirelles Ferreira, 1660, Sala 1906 - Jardim Botânico, Ribeirão Preto/SP - CEP 14021-630
          </Typography>
          <Typography variant="body2" color="textSecondary" align="center">
          ® Z Doctors – Todos os direitos reservados. Endereço eletrônico: https://zdoctors/
          </Typography>
        </Grid>
      </Grid>
    </Container>
  );
}